import React, { useState, useEffect } from 'react';
import { Link, NavLink} from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { Media } from '../../Object';
import { useSwipeable } from 'react-swipeable';
import Button from '../../Object';

const Nav = (props) => {

  const [ pages, setPages ] = useState([]); // 固定ページ情報
  const [ loading, setLoading ] = useState(false);
  const [ swipeStyle, setSwipeStyle ] = useState({});
  const linkClass = {
    header: {
      active: 'p-nav__link p-nav__link--active c-text__med c-text--bold',
      anActive: 'p-nav__link c-text__med c-text--bold',
      contact: 'c-text__med c-text--bold p-nav__link--contact c-text--white'
    },
    footer: {
      active: 'p-nav__link--footer c-text__normal c-text--bold c-text--white',
      anActive: 'p-nav__link--footer c-text__normal c-text--bold c-text--white',
      contact: 'c-text__med c-text--bold p-nav__link--contact c-text--white'
    },
  }

  const position = props.position;

  const viewMenu = [
    'home',
    'recruit',
    'service',
    'qa',
    'works',
    'posts',
    'about',
    'contact'
  ];

  useEffect(() => {
    fetch(`${tmp_path.site_url}/wp-json/wp/v2/pages`)
      .then( response => response.json() )
      .then( data => {
        data = data.reverse();
        setPages(data);
      })
      .then(setLoading(true));
  }, []);

  const Scroll = (props) => {
    setTimeout(() => {
      let margin = 126;
      const rect = props.getBoundingClientRect();
      const target = rect.top - margin + window.pageYOffset;
      scrollTo({
        top: target,
        left: 0,
        behavior: "smooth",
      });
    }, 800);
  };

  const toLink = (link) => {
    if(link == 'home') {
      return '/';
    } else if (link == 'qa'){
      return '/service/#qa';
    } else {
      return `/${link}/`;
    }
  };

  let Items = pages.map((page, key) => {
    if(viewMenu.indexOf(page.slug) !== -1 && props.remove.indexOf(page.slug) == -1) {
      let link = toLink(page.slug);
      if(link.indexOf('#') !== -1) {
        return (
          <li key={key}>
            <HashLink
              to={toLink(page.slug)}
              className={linkClass[position].anActive}
              data-state={ props.state ? props.state : props.active ? 'active' : '' }
              scroll={(el) => Scroll(el)}
            >
              {page.title.rendered}
            </HashLink>
          </li>
        );
      } else {
        return(
          <li key={key}>
            <NavLink
              to={toLink(page.slug)}
              className={({ isActive }) => (isActive ? linkClass[position].active : linkClass[position].anActive)}
              data-state={ props.state ? props.state : props.active ? 'active' : '' }
            >
              {page.title.rendered}
            </NavLink>
          </li>
        )
      }
    }
  })

  let HeaderContact = () => {
    if(props.position == 'header') {
      return(
        <>
          <Link className={`${linkClass[position].contact}`} to='/contact/'>
            <Media class="p-nav__img--icon" src="common/icon-mail" alt="mail"></Media>
            Contact
          </Link>
          <a className={`${linkClass[position].contact} p-nav__link--contact--phone sp`} href="tel:0789280200">
            <Media class="p-nav__img--icon" src="common/icon-phone" alt="phone"></Media>
            078-928-0200
          </a>
        </>
      )
    }
  }

  return(
    <>
      <div className={`p-nav__wrap ${props.open ? 'p-nav__wrap--open' : ''}`} data-state={props.position}>
        <ul style={swipeStyle} className={`p-nav__list ${props.open ? 'p-nav__list--open' : ''}`} data-state={ props.position }>
          { props.position == 'header' && (
            <i className="p-nav__list--button" data-state={props.open} onClick={() => props.toggleOpen() }></i>
          )}
          { Items }
        </ul>
      </div>
    </>
  )
}

export default Nav;
